import * as React from 'react';
import Svg, {SvgProps, Path} from 'react-native-svg';
const SvgComponent = (props: SvgProps) => (
  <Svg
    width={78}
    height={78}
    viewBox={'0 0 78 78'}
    {...props}
    fill="none"
    stroke="none">
    <Path
      fill={props.fill || '#3F62A1'}
      fillRule="evenodd"
      d="M39 68.64c18.954 0 34.32-15.366 34.32-34.32S57.954 0 39 0 4.68 15.366 4.68 34.32c0 10.673 4.872 20.207 12.512 26.502.012.01.002.03-.013.024a.014.014 0 0 0-.019.014v10.644c0 2.98 3.14 4.913 5.8 3.572l12.012-6.055a4.256 4.256 0 0 1 2.148-.432c.623.034 1.25.051 1.88.051Z"
      clipRule="evenodd"
    />
    <Path
      fill={props.stroke || '#fff'}
      fillRule="evenodd"
      d="M43.63 20.432a10.087 10.087 0 0 0-13.46 4.49c-.52 1.028.158 2.188 1.272 2.486l.672.18c1.113.298 2.23-.407 2.94-1.316a5.221 5.221 0 0 1 6.423-1.473 5.217 5.217 0 0 1-.63 9.62c-.804.277-1.02.277-1.847.277h-.696a2.087 2.087 0 0 0-2.087 2.087v3.478c0 1.152.935 2.087 2.087 2.087H39a2.087 2.087 0 0 0 2.087-2.087c0-.51.37-.943.86-1.085a10.088 10.088 0 0 0 1.683-18.745Z"
      clipRule="evenodd"
    />
  </Svg>
);
export default SvgComponent;
